
import { useUserStore } from '@/stores/user';
import { useEventSource } from '@vueuse/core'
import { ref, watch } from "vue";

let sseInstance: { close: () => void } | null = null;

export const initSSE = (url: any) => {
const token = localStorage.getItem('token')
const clientId = process.env.VUE_APP_CLIENT_ID ?? "1";
const messageArray = ref<string[]>([])
  url = url + '?Authorization=Bearer ' + token + '&clientid=' + clientId;
  const { data, error } = useEventSource(url, [], {
    autoReconnect: {
      retries: 10,
      delay: 3000,
      onFailed() {
        console.log('Failed to connect after 10 retries');
      }
    }
  });

  watch(error, () => {
    console.log('SSE connection error:', error.value);
    error.value = null;
  });

  watch(data, () => {
    if (!data.value) return; 
    messageArray.value.push(data.value)
    const msgIDList = messageArray.value.map(item => {
      const match = item.match(/id=(\d+)/);
      return match ? parseInt(match[1]) : null;
    }).filter(id => id !== null);
    const userStore = useUserStore()
    userStore.setMsgList(msgIDList)


    const activityDataList = messageArray.value
    .map(item => {
      const idMatch = item.match(/id=(\d+)/);
      const typeMatch = item.match(/activityType=(\d+)/);
      return {
        id: idMatch ? parseInt(idMatch[1]) : null,
        activityType: typeMatch ? parseInt(typeMatch[1]) : null
      };
    })
    .filter(
      (item): item is { id: number; activityType: number } =>
        item.id !== null && item.activityType !== null
    ); 

  const activityNotice = activityDataList.reduce((acc, { id, activityType }) => {
    let group = acc.find(g => g.id === activityType);
    if (!group) {
      group = { id: activityType, msgList: [] };
      acc.push(group);
    }
    group.msgList.push(id);
    return acc;
  }, [] as { id: number; msgList: number[] }[]);

  const totalMsgListCount = activityNotice.reduce(
    (sum, group) => sum + group.msgList.length,
    0
  );
  userStore.setActivityMsgList(activityNotice);
  });
};

export const closeSSE = () => {
  if (sseInstance) {
    console.log('Closing SSE connection');
    sseInstance.close();
    sseInstance = null;
  }
};

export const restartSSE = (url: string) => {
  closeSSE();
  initSSE(url);
};
